import React from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';

interface ErrorStateProps {
  message: string;
  title?: string;
  retryLabel?: string;
  onRetry?: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  message,
  title = 'Nao foi possivel carregar os dados',
  retryLabel = 'Tentar novamente',
  onRetry,
}) => {
  return (
    <div className="rounded border border-rose-200 dark:border-rose-900/60 bg-rose-50/40 dark:bg-rose-950/20 shadow-sm p-[var(--card-padding)]">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-md bg-rose-100 dark:bg-rose-900/40 text-rose-700 dark:text-rose-300 border border-rose-200 dark:border-rose-900/60 flex items-center justify-center shrink-0">
          <AlertTriangle size={16} />
        </div>
        <div className="min-w-0">
          <h3 className="text-sm font-semibold text-rose-800 dark:text-rose-300">{title}</h3>
          <p className="text-sm text-slate-700 dark:text-zinc-300 mt-1">{message}</p>
          {onRetry && (
            <button
              type="button"
              onClick={onRetry}
              className="mt-3 inline-flex items-center gap-1.5 h-[var(--input-height)] px-4 rounded-md border border-rose-300 dark:border-rose-800 bg-white dark:bg-zinc-900 text-xs font-semibold text-rose-700 dark:text-rose-300 hover:bg-rose-50 dark:hover:bg-rose-950/30"
            >
              <RotateCcw size={12} />
              {retryLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
